import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './Navigation';
import Home from './Home';
import Table from './Table';
import Edit from './Edit';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function BodyClassSetter() {
  const location = useLocation();

  useEffect(() => {
    const body = document.querySelector('body');
    if (location.pathname === '/') {
      body.classList.add('radial-bg', 'flex-center');
      body.classList.remove('body--dashboard');
    } else if (location.pathname === '/table') {
      body.classList.add('body--dashboard');
      body.classList.remove('radial-bg', 'flex-center');
    } else {
      body.classList.remove('radial-bg', 'flex-center', 'body--dashboard');
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <Navigation />
      <BodyClassSetter />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/table' element={<Table />} />
        <Route path="/edit/:id"  element={<Edit />} />
      </Routes>
    </Router>
  );
}

export default App;
